import { render } from "./up2_bom_show.vue?vue&type=template&id=6baa73db&scoped=true"
import script from "./up2_bom_show.vue?vue&type=script&lang=js"
export * from "./up2_bom_show.vue?vue&type=script&lang=js"

import "./up2_bom_show.vue?vue&type=style&index=0&id=6baa73db&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baa73db"]])

export default __exports__